<ng-container *transloco="let t">
  <!-- begin:: Title -->
  <h4 mat-dialog-title class="fs-4 border-bottom">
    <span class="fw-semibold text-primary" transloco="label_customer_information"></span>
    <p class="fs-7 my-2 text-gray-600" transloco="paragraph_visitor_setting_dialog_message"></p>
  </h4>
  <!-- end:: Title -->

  <!-- begin:: Body -->
  <div mat-dialog-content>
    <!-- begin:: Form -->
    @if (settingForm) {
      <form [formGroup]="settingForm" role="form" class="form w-100" novalidate>
        <!-- begin:: Customer Type -->
        <div class="form-group mt-3 mb-7">
          <mat-radio-group [color]="'primary'" formControlName="customer_type" [attr.aria-label]="t('sentence_select_an_customer_type')">
            <mat-radio-button class="me-5" value="1">
              <!-- Private -->
              <i class="bi bi-person-fill fs-3 me-1"></i>
              <span class="fw-semibold" transloco="label_private"></span>
            </mat-radio-button>
            <mat-radio-button class="me-5" value="2">
              <!-- Bussiness -->
              <i class="bi bi-building-fill fs-4 me-1"></i>
              <span class="fw-semibold" transloco="label_business"></span>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <!-- end:: Customer Type -->
        <!-- begin:: Language -->
        <div class="form-group">
          <mat-form-field class="mat-form-field-fluid">
            <mat-label transloco="label_language"> </mat-label>
            <mat-select formControlName="language">
              <!-- begin:: Selected language view -->
              <mat-select-trigger>
                @if (settingForm.controls.language.value?.flag) {
                  <img class="h-20px w-20px rounded me-2" [src]="(settingForm.controls.language.value?.flag)" [alt]="(settingForm.controls.language.value?.language)" />
                }
                <span>{{ settingForm.controls.language.value?.language }}</span>
              </mat-select-trigger>
              <!-- end:: Selected language view -->
              <!-- begin:: Locale list -->
              @for (item of localeList; track item) {
                <mat-option [value]="item">
                  <img loading="lazy" class="h-20px w-20px rounded me-2" [src]="(item?.flag)" [alt]="(item?.language)" />
                  <span>{{ item?.language }} </span>
                </mat-option>
              }
              <!-- end:: Locale list -->
            </mat-select>
          </mat-form-field>
        </div>
        <!-- end:: Language -->
        <!-- begin:: Country -->
        <div class="form-group">
          <mat-form-field class="mat-form-field-fluid">
            <mat-label>
              <span transloco="label_country"></span>
              @if (loadingCountries()) {
                <mat-spinner class="spinner float-end" diameter="20"> </mat-spinner>
              }
            </mat-label>
            <mat-select formControlName="country">
              <!-- begin:: Selected country view -->
              <mat-select-trigger>
                @if (settingForm.controls.country.value?.flag) {
                  <img class="h-20px w-20px rounded me-2" [src]="'./assets/media/flags/' + (settingForm.controls.country.value?.flag) + '.svg'" [alt]="(settingForm.controls.country.value?.country)" />
                }
                <span>{{ settingForm.controls.country.value?.country }} </span>
              </mat-select-trigger>
              <!-- end:: Selected country view -->
              <!-- begin:: Search by country name -->
              <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchCountryTxt" placeholderLabel="{{ 'sentence_search_by_country_name' | transloco }}" noEntriesFoundLabel="{{ 'sentence_country_not_found' | transloco }}" [ngModelOptions]="{ standalone: true }">
                </ngx-mat-select-search>
              </mat-option>
              <!-- end:: Search by country name -->
              <!-- begin:: Country list -->
              @for (item of logisticCountries | searchFilter: "country" : searchCountryTxt; track item) {
                <mat-option [value]="item">
                  <img loading="lazy" class="h-20px w-20px rounded me-2" [src]="'./assets/media/flags/' + (item?.flag) + '.svg'" [alt]="(item?.country)" />
                  <span>{{ item?.country }} </span>
                </mat-option>
              }
              <!-- end:: Country list -->
            </mat-select>
          </mat-form-field>
        </div>
        <!-- end:: Country -->
        <!-- begin:: Currency -->
        <div class="form-group">
          <mat-form-field class="mat-form-field-fluid">
            <mat-label transloco="label_currency"> </mat-label>
            <mat-select formControlName="currency">
              <!-- begin:: Selected currency view -->
              <mat-select-trigger>
                @if (settingForm.controls.currency.value?.flag) {
                  <img class="h-20px w-20px rounded me-1" [src]="(settingForm.controls.currency.value?.flag)" [alt]="(settingForm.controls.currency.value?.label)" />
                }
                <span>
                  {{ settingForm.controls.currency.value?.symbol }} -
                  {{ settingForm.controls.currency.value?.label }}
                </span>
              </mat-select-trigger>
              <!-- end:: Selected currency view -->
              <!-- begin:: Currency list -->
              @for (item of currencyList; track item) {
                <mat-option [value]="item">
                  <img loading="lazy" class="h-20px w-20px rounded me-2" [src]="(item?.flag)" [alt]="(item?.label)" />
                  <span>{{ item?.symbol }} - {{ item?.label }}</span>
                </mat-option>
              }
              <!-- end:: Currency list -->
            </mat-select>
          </mat-form-field>
        </div>
        <!-- end:: Currency -->
        <!-- begin:: Language Changed -->
        @if (currentLanguage !== settingForm.controls.language.value?.locale) {
          <p class="alert alert-primary" transloco="paragraph_after_changing_language"></p>
        }
        <!-- end:: Language Changed -->
      </form>
    }
    <!-- end:: Form -->
  </div>
  <!-- end:: Body -->

  <!-- begin:: Action Buttons -->
  <div mat-dialog-actions align="end">
    <button type="button" mat-dialog-close mat-button class="me-2">
      <span transloco="label_cancel"></span>
    </button>
    <button [disabled]="loading()" type="submit" mat-flat-button (click)="onApplySetting()">
      <span transloco="label_save_changes"></span>
      @if (loading()) {
        <span class="spinner-border spinner-border-sm ms-2"></span>
      }
    </button>
  </div>
  <!-- end:: Action Buttons -->
</ng-container>
